import React from 'react';
import _ from 'lodash';

import SpotWorkersContext from '../../services/spotWorkers/SpotWorkersContext';

import { SearchMenuHeader } from './SearchMenuHeader';
import { TextBox } from '../textbox/TextBox';

import {
  WORKER_IMAGE_CCUS_SYNCED_STATUS,
  WORKER_IMAGE_REGISTER_STATUS,
  ERROR_STATUS,
  SPOT_WORKER_STATUS,
  SPOT_WORKER_RESIDENCE_TYPE,
  SPOT_WORKER_TYPE,
} from '../../utilities/constants';

import Styles from '../../styles/componentStyle/spotWorkers/spotWorkers.scss';

export class SearchForm extends React.Component {
  constructor(props) {
    super(props);
  }

  // 画面表示
  render() {
    const nonResidentTypes = _.filter(SPOT_WORKER_TYPE, {
      residenceTypeId: SPOT_WORKER_RESIDENCE_TYPE.NON_RESIDENT.id,
    });
    const spotWorkerNameLabel =
      this.props.spotWorkerType === SPOT_WORKER_RESIDENCE_TYPE.RESIDENT
        ? data.searchTitle.spotWorkerName.resident
        : data.searchTitle.spotWorkerName.nonResident;
    return (
      <SpotWorkersContext.Consumer>
        {({
          searchForm,
          searchFormHandle,
          clearSearchProperty,
          inputSpotWorkerName,
          inputCompanyName,
          checkSingleData,
          doSearch,
        }) => (
          <div className={`${Styles.search} master-slide-view__searchform`}>
            <div className='search-form'>
              <SearchMenuHeader
                total={searchForm.total}
                isOpened={searchForm.isOpened}
                searchFormHandle={() => {
                  searchFormHandle();
                }}
                clearSearchProperty={() => {
                  clearSearchProperty();
                }}
              />
              <div
                id='search-form-accordion'
                className={searchForm.isOpened ? 'accordion show' : 'accordion'}
              >
                <div className='search-form__body'>
                  <div className='form form--search-form'>
                    <div className='form__group flex-wrap'>
                      {this.props.spotWorkerType ===
                        SPOT_WORKER_RESIDENCE_TYPE.NON_RESIDENT && (
                        <React.Fragment>
                          {/* 入退場者種別 */}
                          <div className='search-form-element'>
                            <div className='form__label'>
                              <span className='label'>
                                {data.searchTitle.workerType}
                              </span>
                            </div>
                            <div className='form__element'>
                              {_.map(nonResidentTypes, item => {
                                return (
                                  <label className='checkbox' key={item.id}>
                                    <input
                                      type='checkbox'
                                      name='checkbox-worker-type'
                                      checked={_.some(
                                        searchForm.workerType,
                                        item
                                      )}
                                      onChange={() =>
                                        checkSingleData('workerType', item)
                                      }
                                    />
                                    <i
                                      className='i-square i-2x'
                                      aria-hidden='true'
                                    />
                                    <span className='radio-search-span'>
                                      {item.name}
                                    </span>
                                  </label>
                                );
                              })}
                            </div>
                          </div>
                          {/* 会社名 */}
                          <div className='search-form-element'>
                            <TextBox
                              label={data.searchTitle.companyName}
                              placeholder={data.placeholder.companyName}
                              value={searchForm.companyName}
                              onInput={event => {
                                inputCompanyName(event.target.value);
                              }}
                            />
                          </div>
                        </React.Fragment>
                      )}
                      {/* 氏名 */}
                      <div className='search-form-element'>
                        <TextBox
                          label={spotWorkerNameLabel}
                          placeholder={data.placeholder.spotWorkerName}
                          value={searchForm.spotWorkerName}
                          onInput={event => {
                            inputSpotWorkerName(event.target.value);
                          }}
                        />
                      </div>
                      {/* 顔写真 */}
                      <div className='search-form-element'>
                        <div className='form__label'>
                          <span className='label'>
                            {data.searchTitle.faceImage}
                          </span>
                        </div>
                        <div className='form__element'>
                          {_.map(WORKER_IMAGE_REGISTER_STATUS, item => {
                            return (
                              <label className='checkbox' key={item.id}>
                                <input
                                  type='checkbox'
                                  name='checkbox'
                                  checked={_.some(
                                    searchForm.workerImageRegisterStatusList,
                                    item
                                  )}
                                  onChange={() =>
                                    checkSingleData(
                                      'workerImageRegisterStatusList',
                                      item
                                    )
                                  }
                                />
                                <i
                                  className='i-square i-2x'
                                  aria-hidden='true'
                                />
                                <span className='radio-search-span'>
                                  {item.name}
                                </span>
                              </label>
                            );
                          })}
                        </div>
                      </div>
                      {/* 顔認証機器連携 */}
                      <div className='search-form-element'>
                        <div className='form__label'>
                          <span className='label'>
                            {data.searchTitle.connectedFaceMachine}
                          </span>
                        </div>
                        <div className='form__element'>
                          {_.map(
                            _.filter(
                              WORKER_IMAGE_CCUS_SYNCED_STATUS,
                              'canSearch'
                            ),
                            item => {
                              return (
                                <label className='checkbox' key={item.id}>
                                  <input
                                    type='checkbox'
                                    name='checkbox'
                                    checked={_.some(
                                      searchForm.workerImageCcusSyncedStatusList,
                                      item
                                    )}
                                    onChange={() =>
                                      checkSingleData(
                                        'workerImageCcusSyncedStatusList',
                                        item
                                      )
                                    }
                                  />
                                  <i
                                    className='i-square i-2x'
                                    aria-hidden='true'
                                  />
                                  <span className='radio-search-span'>
                                    {item.name}
                                  </span>
                                </label>
                              );
                            }
                          )}
                        </div>
                      </div>
                      {/* エラー状況 */}
                      <div className='search-form-element'>
                        <div className='form__label'>
                          <span className='label'>
                            {data.searchTitle.hasError}
                          </span>
                        </div>
                        <div className='form__element'>
                          {_.map(ERROR_STATUS, item => {
                            return (
                              <label className='checkbox' key={item.id}>
                                <input
                                  type='checkbox'
                                  name='checkbox'
                                  checked={_.some(
                                    searchForm.hasErrorList,
                                    item
                                  )}
                                  onChange={() =>
                                    checkSingleData('hasErrorList', item)
                                  }
                                />
                                <i
                                  className='i-square i-2x'
                                  aria-hidden='true'
                                />
                                <span className='radio-search-span'>
                                  {item.name}
                                </span>
                              </label>
                            );
                          })}
                        </div>
                      </div>
                      {/* ステータス */}
                      <div className='search-form-element'>
                        <div className='form__label'>
                          <span className='label'>
                            {data.searchTitle.status}
                          </span>
                        </div>
                        <div className='form__element'>
                          {_.map(SPOT_WORKER_STATUS, item => {
                            return (
                              <label className='checkbox' key={item.id}>
                                <input
                                  type='checkbox'
                                  name='checkbox'
                                  checked={_.some(searchForm.statusList, item)}
                                  onChange={() =>
                                    checkSingleData('statusList', item)
                                  }
                                />
                                <i
                                  className='i-square i-2x'
                                  aria-hidden='true'
                                />
                                <span className='radio-search-span'>
                                  {item.name}
                                </span>
                              </label>
                            );
                          })}
                        </div>
                      </div>
                      {/* 検索ボタン */}
                      <div className='search-form-element'>
                        <button
                          className='btn-fixedsize--stay search-form__btn'
                          style={{ marginTop: '26px' }}
                          onClick={() => doSearch()}
                        >
                          {data.searchButtonTitle}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </SpotWorkersContext.Consumer>
    );
  }
}

// 定数
const data = {
  searchButtonTitle: '検索',
  searchTitle: {
    workerType: '入退場者種別',
    companyName: '会社名',
    faceImage: '顔写真',
    hasError: 'エラー状況',
    spotWorkerName: {
      resident: '氏名（かな検索可）',
      nonResident: '氏名（カナ検索可）',
    },
    connectedFaceMachine: '顔写真送信',
    status: 'ステータス',
  },
  placeholder: {
    spotWorkerName: '氏名を入力',
    companyName: '会社名を入力',
  },
};



// WEBPACK FOOTER //
// ./src/components/searchmenus/SpotWorkersSearch.jsx